export class HowItWorksStep {
  constructor(public id: string, public icon: string, public description: string) {}
}

export const iAcceptChallengesSteps: HowItWorksStep[] = [
  {
    id: "1",
    icon: require("@/assets/images/how-it-works/icons/1-find.svg"),
    description: "home.how_it_works.solve_challenge.step1"
  },
  {
    id: "2",
    icon: require("@/assets/images/how-it-works/icons/2-find.svg"),
    description: "home.how_it_works.solve_challenge.step2"
  },
  {
    id: "3",
    icon: require("@/assets/images/how-it-works/icons/3-find.svg"),
    description: "home.how_it_works.solve_challenge.step3"
  },
  {
    id: "4",
    icon: require("@/assets/images/how-it-works/icons/4-find.svg"),
    description: "home.how_it_works.solve_challenge.step4"
  },
  {
    id: "5",
    icon: require("@/assets/images/how-it-works/icons/5-find.svg"),
    description: "home.how_it_works.solve_challenge.step5"
  }
];

export const iHaveAChallengeSteps: HowItWorksStep[] = [
  {
    id: "1",
    icon: require("@/assets/images/how-it-works/icons/1.svg"),
    description: "home.how_it_works.have_challenge.step1"
  },
  {
    id: "2",
    icon: require("@/assets/images/how-it-works/icons/2.svg"),
    description: "home.how_it_works.have_challenge.step2"
  },
  {
    id: "3",
    icon: require("@/assets/images/how-it-works/icons/3.svg"),
    description: "home.how_it_works.have_challenge.step3"
  },
  {
    id: "4",
    icon: require("@/assets/images/how-it-works/icons/4.svg"),
    description: "home.how_it_works.have_challenge.step4"
  }
];
